import { JobStatusUtils, JobStatusV4 } from './optimization.model';
import { hasRootRole, hasSuperUserOrAbove } from './user-role.constants';

/** A job has pod logs only once it has moved past CREATED/SENT onto a pod. */
export function hasJobStarted(status: JobStatusV4): boolean {
  return status !== JobStatusV4.CREATED && status !== JobStatusV4.SENT;
}

export function canViewJobLogs(
  role: string | undefined,
  hasLogsPermission: boolean
): boolean {
  return hasRootRole(role) || hasLogsPermission;
}

export function canDownloadArtifacts(
  role: string | undefined,
  hasArtifactsPermission: boolean,
  status: JobStatusV4
): boolean {
  return (hasRootRole(role) || hasArtifactsPermission) && hasJobStarted(status);
}

/**
 * The endpoint is reserved to the internal roles, and it refuses anything that is still
 * computing or that owns a result plan. Both halves are checked so the button is never
 * offered for a request the server would only turn down.
 */
export function canOpenOptimizations(
  role: string | undefined,
  flagActive: boolean
): boolean {
  return flagActive || hasSuperUserOrAbove(role);
}

export function canDeleteJob(role: string | undefined, status: JobStatusV4): boolean {
  return hasSuperUserOrAbove(role) && JobStatusUtils.isDeletableStatus(status);
}
